<template>
  <div class="froala-editor-wrap">
    <froala
      id="froala-editor"
      :tag="'textarea'"
      :config="config"
      v-model="currentValue"
    />
  </div>
</template>

<script>
  const tool = [
    "undo",
    "redo",
    "clearFormatting",
    "bold",
    "italic",
    "underline",
    "strikeThrough",
    "fontFamily",
    "fontSize",
    "textColor",
    "color",
    "backgroundColor",
    "inlineStyle",
    "paragraphFormat",
    "align",
    "formatOL",
    "formatUL",
    "outdent",
    "indent",
    "quote",
    "insertLink",
    "insertImage",
    "insertVideo",
    "embedly",
    "insertFile",
    "insertTable",
    // "emoticons",
    "specialCharacters",
    "insertHR",
    "selectAll",
    "print",
    "spellChecker",
    "html",
    "help",
    "fullscreen"
  ];
  const tool2 = {
    'moreText': {
      'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize',
        'textColor', "color", 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'],
      buttonsVisible: 2
    },
    'moreParagraph': {
      'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL',
        'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'],
      buttonsVisible: 2
    },
    'moreRich': {
      'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'fontAwesome',
        'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
      buttonsVisible: 2
    },
    'moreMisc': {
      'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
      buttonsVisible: 2
    }
  }
  export default {
    name: "RYRichTextEditor",
    props: {
      content: String,
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请输入内容'
      },
      index: {
        type: Number,
        default: 1
      },
      heightMin: {
        type: Number,
        default: 300
      },
      heightMax: {
        type: Number,
        default: 800
      },
      isSimpleToolBar: {
        type: Boolean,
        default: true
      },
      installBtns: {
        type: Array,
        default: () => []
      },
      showQuickBtn: {
        type: Boolean,
        default: true
      },
      // 最大字数限制
      charCounterMax: {
        type: Number,
        default: -1
      },
    },
    data() {
      const that = this;
      return {
        currentValue: this.content,
        editor: null,
        editorInit: false,

        config: {
          key: "YNB3fH3A7C9A6D6E3E2C-8TMIBDIa1NTMNZFFPFZc1d1Ib2a1E1fA4A3G3G3F2C6C4C4E3E3==", // Pass your key here
          heightMax: this.heightMax,
          heightMin: this.heightMin,
          charCounterMax: this.charCounterMax,
          // toolbarButtons: this.isSimpleToolBar ? tool2 : [...tool, this.installBtns],
          toolbarButtonsXS: this.isSimpleToolBar ? tool2 : [...tool, this.installBtns],
          // fontFamilySelection: true, // 字体选择后显示选择详情
          // fontSizeSelection: true, // 字号选择后显示选择详情
          // paragraphFormatSelection: true, // 段落选择后显示选择详情
          // fontFamily: {
          //   'STSong': '宋体',
          //   'STFangsong': '仿宋',
          //   'STKaiti': '楷体',
          //   'Microsoft YaHei': '微软雅黑',
          //   'STHeiti': '黑体',
          //   'Arial,Helvetica,sans-serif': 'Arial',
          //   'Georgia,serif': 'Georgia',
          //   'Impact,Charcoal,sans-serif': 'Impact',
          //   'Tahoma,Geneva,sans-serif': 'Tahoma',
          //   "'Times New Roman',Times,serif": 'Times New Roman',
          // },
          attribution: false, // 去logo
          charCounterCount: this.charCounterMax > -1, // 统计字数
          // theme: "dark",//主题
          placeholderText: this.placeholder,
          language: "zh_cn", //国际化
          dragInline: true,
          imageEditButtons: ['imageReplace', 'imageAlign', 'imageCaption', 'imageRemove', '|', 'imageLink', 'linkOpen',
            'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize'],
          imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
          quickInsertEnabled: this.showQuickBtn,
          imagePaste: true, // 图片粘贴
          imagePasteProcess: false, //  图片粘贴进度条
          // videoResponsive: true,
          // videoResize: true, // 视频调整大小
          // videoMove: true,
          // videoTextNear: true,
          // videoUpload: true,
          videoInsertButtons: ['videoBack', '|', 'videoUpload', 'videoByURL', 'videoEmbed'],
          // videoEditButtons: ['videoReplace', 'videoRemove', '|', 'videoDisplay', 'videoAlign', 'videoSize', 'autoplay'],
          // videoSizeButtons: ['videoBack'],
          quickInsertButtons: ["image", "table", "ul", "ol", "hr"], //快速插入项
          // toolbarVisibleWithoutSelection: true,//是否开启 不选中模式
          // disableRightClick: true,//是否屏蔽右击
          colorsHEXInput: true, //关闭16进制色值
          toolbarSticky: false, //操作栏是否自动吸顶,
          // Colors list.
          colorsBackground: [
            "#15E67F",
            "#E3DE8C",
            "#D8A076",
            "#D83762",
            "#76B6D8",
            "REMOVE",
            "#1C7A90",
            "#249CB8",
            "#4ABED9",
            "#FBD75B",
            "#FBE571",
            "#FFFFFF"
          ],
          colorsStep: 6,
          colorsText: [
            "#15E67F",
            "#E3DE8C",
            "#D8A076",
            "#D83762",
            "#76B6D8",
            "REMOVE",
            "#1C7A90",
            "#249CB8",
            "#4ABED9",
            "#FBD75B",
            "#FBE571",
            "#FFFFFF"
          ],
          zIndex: 2501,
          // autofocus: true,
          events: {
            initialized: function () {
              that.editor = this;
              that.editorInit = true
            },
            blur: () => {
              this.$emit("blur");
            },
            contentChanged: () => {
              if (this.editorInit) {
                this.EditorChange();
              }
            },
            "image.beforeUpload": images => {
              //自定义上传图片
              console.log("file.beforeUploadImage", images)
              let file = images[0]
              if (file.constructor === Blob) {
                file = new window.File([file], '', {type: 'image/png'})
                console.log('files', file)
              }
              this.beforeUpload(file);
              return false;
            },
            'image.beforePasteUpload': image => {
              // 粘贴图片
              console.log("file.beforePasteUpload", image)
              let src = image.getAttribute('src')
              image.classList.remove("fr-dib");
              image.classList.add('fr-fic', 'fr-dii')
              const file = this.$RyFs.base64ToFile(src)
              this.beforeUpload(file, image);
              return false;
            },
            'image.inserted': function ($img, response) {
              // Do something here.
              // this is the editor instance.
              console.log('inserted', $img, response);
            },
            "file.beforeUpload": files => {
              // Image was uploaded to the server.
              console.log("file.beforeUploadFile", files)
              this.beforeUploadFile(files[0]);
              return false;
            },
            "video.beforeUpload": videos => {
              // Image was uploaded to the server.
              console.log('video.beforeUpload', videos)
              this.beforeUploadVideo(videos[0])
              return false;
            },
            'video.codeError': function (code) {
              // Do something here.
              // this is the editor instance.
              console.log('video.codeError', code);
            },
            'video.linkError': function (link) {
              // Do something here.
              // this is the editor instance.
              console.log('video.linkError', link);
            }
          }
        }
      }
    },
    created() {
    },
    mounted() {
      setTimeout(() => {
        this.setIndex(this.index);
      }, 200);
    },
    methods: {
      //更改富文本层级
      setIndex(val) {
        this.$nextTick(() => {
          let dv = document.getElementsByClassName("fr-box");
          for (let i in dv) {
            if (!dv[i].style) {
              return;
            }
            dv[i].style.cssText = "z-index:" + val;
          }
        });
      },
      //富文本中提取纯文本
      getSimpleText: html => {
        let re1 = new RegExp('<p data-f-id="pbf".+?</p>', "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
        let msg = html.replace(re1, ""); //执行替换成空字符
        return msg;
      },
      EditorChange() {

        this.$emit('update:content', this.currentValue)
        this.$emit('change')
        // if (this.editor == null) return;
        // console.log(this.editor, "this.editor");
        // const editorCount = this.editor.charCounter.count();
        // this.body.textLen = editorCount;
        // this.body.leftoverLen = this.body.sumLen - editorCount;
        // this.$emit("change", this.body);
      },
      beforeUpload(file, image) {
        const formData = new FormData();
        formData.append("formFile", file);
        console.log('beforeUpload', file)
        const loading = this.$toast.loading({message: '上传中...'})
        this.$RyFs.upload([file])
          .then(urlList => urlList[0])
          .then(url => {
            console.log('urlList', url)
            console.log('this.editor', this.editor)
            //插入图片
            if (image) {
              image.src = url;
            } else {
              this.editor.html.insert(
                "<img src=" + url + ">", //HTML
                false //在插入之前是否应清除HTML
              ); //插入图片
            }
          })
          .catch(console.error)
          .finally(() => {
            loading.clear()
            this.editor.popups.hideAll()
          })

      },

      beforeUploadFile(file) {
        const formData = new FormData();
        formData.append("formFile", file);
        console.log('beforeUpload', file)
        const loading = this.$toast.loading({message: '上传中...'})
        this.$RyFs.upload([file])
          .then(urlList => urlList[0])
          .then(url => {
            console.log('urlList', url)
            //插入图片
            const previewUrl = `${location.origin}/form/file/transit_preview?u=${encodeURIComponent(url)}`
            this.editor.html.insert(
              '<a class="fr-file" href="' + previewUrl + '" target="_blank" rel="noopener noreferrer">' + file.name + '</a>', //HTML
              false //在插入之前是否应清除HTML
            ); //插入图片
          })
          .catch(console.error)
          .finally(() => {
            loading.clear()
          })

      },

      beforeUploadVideo(file) {
        const formData = new FormData();
        formData.append("formFile", file);
        console.log('beforeUpload', file)
        const loading = this.$toast.loading({message: '上传中...'})
        this.$RyFs.upload([file])
          .then(urlList => urlList[0])
          .then(url => {
            console.log('urlList', url)
            //插入图片
            // this.editor.html.insert(
            //   '<video autoplay="autoplay" controls="controls" preload="metadata" class="video">' +
            //   '<source type="video/mp4" src="' + url + '">' +
            //   '</video>', //HTML
            //   false //在插入之前是否应清除HTML
            // ); //插入图片
            // <video class="fr-draggable" controls="" src="" style="width: 600px;"></video>
            this.editor.html.insert(
              '<span class="fr-video fr-dvb fr-draggable fr-active" contenteditable="false" draggable="true"><video class="fr-draggable" autoplay controls="" src="' + url + '"></video></span>', //HTML
              false //在插入之前是否应清除HTML
            );
          })
          .catch(console.error)
          .finally(() => {
            loading.clear()
          })

      },
      // <a class="fr-file" href="blob:http://127.0.0.1:3288/32dad1e6-284c-451e-b91a-d11da977a88d" target="_blank">成考科目2 (1).xlsx</a>
      installField(val) {
        this.editor.html.insert(
          `<span>${val}</span>`, //HTML
          false //在插入之前是否应清除HTML
        ); //插入图片

      }

    }
  }
</script>

<style lang="less">

  .froala-editor-wrap {
    .fr-btn-grp {
      margin: 0 12px !important;
    }

  }

</style>
